import React, { useEffect, useState } from 'react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { UserOnboardingState } from './UserOnboardingState';
import { OnboardingCard } from './OnboardingCard';
import { IonToggle } from '@ionic/react';
import { IonToggleCustomEvent, ToggleChangeEventDetail } from '@ionic/core';
import { AsyncStorageProvider } from '../support/AsyncStorageProvider';
import { useAsyncEffect } from '../support/useAsyncEffect';
import { MixPanelEventEmitter } from '../metrics/MixPanelEventEmitter';
import { CareRecipientSwitcher } from '../navigation/CareRecipientSwitcher';
import { OnboardingModel } from './OnboardingModel';

export const Onboarding: React.FC = () => {
    const storageProvider = useInstance(AsyncStorageProvider);
    const mixpanel = useInstance(MixPanelEventEmitter);

    const model = useInstance(OnboardingModel);
    useSubscription(() => model);

    const userOnboardingState = useInstance(UserOnboardingState);
    useSubscription(() => userOnboardingState);

    const [showCompleted, setShowCompleted] = useState<boolean>(false);

    useEffect(() => {
        userOnboardingState.load();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const showCompletedStorageKey = 'show-completed-onboarding-items';
    useAsyncEffect(async () => {
        const show = await storageProvider.getBooleanProvider(showCompletedStorageKey).get();
        setShowCompleted(show || false);
    }, [storageProvider]);

    const tasks = model.getTasks();

    // expand first card with incomplete tasks
    const expandIndex = tasks.findIndex(c => c.steps.some(t => t.ready && !t.completed));
    const anyCompleteIndex = tasks.findIndex(c => c.steps.some(t => t.completed));

    return (
        <div data-id="onboarding">
            <div style={{margin: 10}}>
                <CareRecipientSwitcher />
            </div>

            {tasks.length > 0 && anyCompleteIndex > -1 &&
                <div style={{padding: 10}}>
                    <IonToggle
                        labelPlacement="end"
                        checked={showCompleted}
                        data-type="show-completed-toggle"
                        onIonChange={(e: IonToggleCustomEvent<ToggleChangeEventDetail<any>>) => {
                            setShowCompleted(e.detail.checked);
                            storageProvider.getBooleanProvider(showCompletedStorageKey).set(e.detail.checked);
                            mixpanel.track(
                                'Onboarding Visibility Toggled', () => ({
                                    'State': e.detail.checked ? 'show completed' : 'hide completed'
                                })
                            );
                        }}
                    >
                        Show Completed
                    </IonToggle>
                </div>
            }

            {tasks.map((task, i) => (
                <OnboardingCard showCompleted={showCompleted} key={task.heading} task={task} expanded={i === expandIndex} />
            ))}
        </div>
    );
};
